export default __webpack_public_path__ + "static/smoke_detector_b.45eaae9468d185fa7c2cce4e903a86b1.png";